export default __webpack_public_path__ + "static/blog5-afbfbdfd40f8d35e591aa5f5c26423f8.jpg";